'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();

var _templateObject = _taggedTemplateLiteral(['\n\tmargin-top: ', 'px;\n\tmargin-bottom: ', 'px;\n\tmargin-left: ', 'px;\n\tmargin-right: ', 'px;\n\tjustify-content: ', ';\n\t', ';\n\t', ';\n\t', '\n\talign-items: center;\n\tcursor: pointer;\n\ttext-decoration: none;\n\t', ';\n\t&:hover {\n\t\tfont-weight: ', ';\n\t}\n'], ['\n\tmargin-top: ', 'px;\n\tmargin-bottom: ', 'px;\n\tmargin-left: ', 'px;\n\tmargin-right: ', 'px;\n\tjustify-content: ', ';\n\t', ';\n\t', ';\n\t', '\n\talign-items: center;\n\tcursor: pointer;\n\ttext-decoration: none;\n\t', ';\n\t&:hover {\n\t\tfont-weight: ', ';\n\t}\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n\tdisplay: inherit;\n\tmargin-right: ', 'px;\n'], ['\n\tdisplay: inherit;\n\tmargin-right: ', 'px;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _getSize = require('../../helpers/getSize');

var _getSize2 = _interopRequireDefault(_getSize);

var _styles = require('./styles');

var _styles2 = require('../icons/styles');

var _sizes = require('../../constants/sizes');

var _text = require('../../constants/text');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }

function _taggedTemplateLiteral(strings, raw) { return Object.freeze(Object.defineProperties(strings, { raw: { value: Object.freeze(raw) } })); }

var LinkComponent = _styledComponents2.default.a(_templateObject, function (_ref) {
	var top = _ref.top;
	return (0, _getSize2.default)(top);
}, function (_ref2) {
	var bottom = _ref2.bottom;
	return (0, _getSize2.default)(bottom);
}, function (_ref3) {
	var left = _ref3.left;
	return (0, _getSize2.default)(left);
}, function (_ref4) {
	var right = _ref4.right;
	return (0, _getSize2.default)(right);
}, function (_ref5) {
	var textAlign = _ref5.textAlign;
	return textAlign === 'left' ? 'flex-start' : textAlign === 'right' ? 'flex-end' : 'center';
}, function (_ref6) {
	var disabled = _ref6.disabled;
	return disabled && 'pointer-events: none;';
}, _styles2.iconWrapperStyles, function (_ref7) {
	var inline = _ref7.inline;
	return !inline ? 'display: flex;' : 'display: inline;';
}, function (_ref8) {
	var size = _ref8.size;
	return size === _sizes.Sizes.lg ? _styles.Link1Styles : size === _sizes.Sizes.sm ? _styles.Link3Styles : _styles.Link2Styles;
}, _text.TextSizes.WeightSemiBold);

var IconWrapper = _styledComponents2.default.span(_templateObject2, (0, _getSize2.default)(_sizes.Sizes.xs));

var Link = function (_React$Component) {
	_inherits(Link, _React$Component);

	function Link() {
		_classCallCheck(this, Link);

		return _possibleConstructorReturn(this, (Link.__proto__ || Object.getPrototypeOf(Link)).apply(this, arguments));
	}

	_createClass(Link, [{
		key: 'render',
		value: function render() {
			var newTab = this.props.newTab || false;

			var inline = this.props.inline || false;

			var propsForLink = {
				href: this.props.href && this.props.href,
				onClick: this.props.clickEvent,
				target: newTab ? '_blank' : '_self',
				inverse: this.props.inverse,
				disabled: this.props.disabled
			};

			var linkComponent = undefined;

			var size = this.props.size || _sizes.Sizes.md;

			linkComponent = _react2.default.createElement(
				LinkComponent,
				_extends({}, propsForLink, {
					inline: this.props.inline,
					secondaryStyle: this.props.secondaryStyle,
					top: this.props.top,
					bottom: this.props.bottom,
					left: this.props.left,
					right: this.props.right,
					textAlign: this.props.textAlign,
					size: size,
					className: this.props.className
				}),
				this.props.icon && _react2.default.createElement(
					IconWrapper,
					null,
					this.props.icon
				),
				this.props.text,
				this.props.children
			);

			return linkComponent;
		}
	}]);

	return Link;
}(_react2.default.Component);

exports.default = Link;